<template>
  <div class="">
    <text-header
      :headerTitle="$t('publicInfo.publicInfo')"
      header-bg="radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)"
    />
    <ol type="I" class="w-container information-list">
      <li>
        <div class="list-nolink" v-html="$t('publicInfo.primaryHeading.h1')" />
        <ol type="A">
          <li>
            <a
              href="https://madrigal-public.s3-eu-central-1.amazonaws.com/public-info/Legislatie.zip"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h1')"
            />
          </li>
          <li>
            <router-link
              :to="{ name: 'leadership', params: { locale: $i18n.locale } }"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h2')"
            />
          </li>
          <li>
            <div
              class="list-nolink"
              v-html="$t('publicInfo.secondaryHeading.h3')"
            />
            <ol>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/rof.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h1')"
                />
              </li>
              <li>
                <a
                  href="https://madrigal-public.s3-eu-central-1.amazonaws.com/public-info/Regulament+intern.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h2')"
                />
              </li>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/Codul+de+conduita+etica+si+integritate.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h14')"
                />
              </li>              
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/organigrama.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h3')"
                />
              </li>
              <li>
                <router-link
                  :to="{ name: 'careers', params: { locale: $i18n.locale } }"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h4')"
                />
              </li>
            </ol>
          </li>
          <li>
            <div
              class="list-nolink"
              v-html="$t('publicInfo.secondaryHeading.h4')"
            />
            <ol>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/D.1.+Lista+obiective+generale+2023.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h5')"
                />
              </li>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/D.2.+Lista+obiective+specifice+-+2023.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h6')"
                />
              </li>
              <li>
                <a
                  href="https://cantusmundi.com/"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h7')"
                />
              </li>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/Plan+de+integritate+2021+-+2025.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h8')"
                />
              </li>              
            </ol>
          </li>
          <li>
            <div
              class="list-nolink"
              v-html="$t('publicInfo.secondaryHeading.h5')"
            />
            <ol>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/Legea+544.zip"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h9')"
                />
              </li>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/raport-de-evaluare-a-implementarii-legii-nr-544-din-2001.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h10')"
                />
              </li>
              <li>
                <a
                  href=""
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h11')"
                />
              </li>
              <li>
                <a
                  href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/raport-de-evaluare-a-implementarii-legii-nr-52-din-2003.pdf"
                  target="_blank"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h12')"
                />
              </li>
              <li>
                <router-link
                  :to="{ name: 'gdpr', params: { locale: $i18n.locale } }"
                  class="cool-link list-link"
                  v-html="$t('publicInfo.tertiaryHeading.h13')"
                />                
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        <div class="list-nolink" v-html="$t('publicInfo.primaryHeading.h2')" />
        <ol type="A">
          <li>
            <a
              href="https://madrigal-public.s3-eu-central-1.amazonaws.com/public-info/Audiente.pdf"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h6')"
            />
          </li>
          <li>
            <a
              href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/bvc.pdf"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h7')"
            />
          </li>
          <li>
            <a
              href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/COFOG.pdf"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h13')"
            />
          </li>
          <li>
            <a
              href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/bilant_contabil.pdf"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h8')"
            />
          </li>
          <li>
            <a
              href=""
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h9')"
            />
          </li>
          <li>
            <router-link
              :to="{ name: 'announcements', params: { locale: $i18n.locale } }"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h10')"
            />
          </li>
          <li>
            <a
              href="http://ruti.gov.ro/"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h14')"
            />
          </li>
          <li>
            <a
              href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/Situatia+drepturilor+salariale+la+01.01.2024.pdf"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h11')"
            />
          </li>
          <li>
            <a
              href="https://madrigal-public.s3.eu-central-1.amazonaws.com/public-info/Declaratii+de+avere+si+interese.zip"
              target="_blank"
              class="cool-link list-link"
              v-html="$t('publicInfo.secondaryHeading.h12')"
            />
          </li>
        </ol>
      </li>
      <li>
        <router-link
          :to="{ name: 'contact', params: { locale: $i18n.locale } }"
          class="cool-link list-link"
          v-html="$t('publicInfo.primaryHeading.h3')"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import TextHeader from "../TextHeader";
export default {
  name: "PublicInformationRoot",
  components: { TextHeader },
};
</script>

<style scoped>
.information-list {
  padding: 4em 2em;
}

.list-link {
  color: black;
  font-size: 1.5em;
  margin-bottom: 0.4em;
}

.list-link::after {
  background-color: black;
}

.list-nolink {
  color: black;
  font-size: 1.5em;
  margin-bottom: 1em;
}
</style>
